import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enJson from "./pages/en.json";
import jaJson from "./pages/ja.json";

// import {Backend} from "i18next-http-backend";
// import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
    // .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        // fallbackLng: "ja",
        // debug: true,

        // interpolation: {
        //     escapeValue: false // not needed for react as it escapes by default
        // }
        debug: true,
        resources: {
            en: { translation: enJson },
            ja: { translation: jaJson },
        },
        lng: "en",
        fallbackLng: false, // フォールバックしない＝keyをそのまま表示
        returnEmptyString: false, // 空文字での定義を許可
    });

export default i18n;
